import BetDrawerSubHeader from "app/components/BetDrawerSubHeader/BetDrawerSubHeader";
import { BetSlipType } from "app/types/betSlipType";
import { MultiplesBetSlipType } from "app/types/multiplesBetSlipType";
import { BetslipListTypes, ResponsiveScreenSizes } from "app/utils/const";
import { PureComponent } from "react";
import Media from "react-media";
import BetBuilderContainer from "../BetBuilder/BetBuilderContainer";
import "./BetSlipLists.scss";
import BetSlipList from "./components/BetSlipList/BetSlipList";
import MultiplesBetSlipList from "./components/MultiplesBetSlipList/MultiplesBetSlipList";

type Props = {
  betSlipList: BetSlipType[];
  multiplesBetSlipList: MultiplesBetSlipType[];
  tab: string;
};

class BetSlipLists extends PureComponent<Props> {
  render: () => any | null | Node = () => {
    const { betSlipList, tab } = this.props;
    return (
      <div className="bet-slip-lists">
        {tab === BetslipListTypes.SINGLES && (
          <Media
            query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
            render={() => <BetDrawerSubHeader />}
          />
        )}

        {tab === BetslipListTypes.SINGLES && (
          <>
            <BetBuilderContainer />
            <BetSlipList betSlipList={betSlipList} />
          </>
        )}
        {tab === BetslipListTypes.MULTIPLES && <MultiplesBetSlipList />}
      </div>
    );
  };
}

export default BetSlipLists as any;
